import { Component, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RoleUsers_Document, RoleUsers } from '../../model/role-users';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'projects/Shared-Lib/component/dialog/dialog.service';
import { FilterDataService } from '../../services/filter-data.service';
import { DataService } from 'projects/Shared-Lib/services/data.service';
import { SelectListItem } from '../../lib/select/select-property';
import { environment } from 'projects/environments/environment';
import { Observable, of, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, switchMap, catchError, map, merge } from 'rxjs/operators';

@Component({
  selector: 'app-role-users-edit',
  templateUrl: './role-users-edit.component.html',
  styleUrls: ['./role-users-edit.component.css']
})
export class RoleUsersEditComponent {
  Doc: RoleUsers_Document;

  // NEW or edit
  DocMode: string = 'NEW';
  Title: string = 'Create';
  ControllerName = 'RoleUsers';
  UserProfileAutoComplete = 'UserProfile/AutoComplete';

  UsersFilter: string;
  SelectedUser: any;
  UserList: any;

  typeahead = new EventEmitter<string>();
  searching: boolean;
  searchFailed: boolean;
  searchList: RoleUsers[] = [];
  searchList$: Observable<any[]>;
  searchListinput$ = new Subject<string>();
  userLoading: boolean = false;

  constructor(private route: ActivatedRoute, private DlgService: DialogService, private router: Router,
    private http: HttpClient, private filterService: FilterDataService, private dataService: DataService) {
    this.Doc = new RoleUsers_Document(dataService);

    this.dataService.getData(this.ControllerName + '/init', null,
      (data) => {
        this.Doc.ddlRole = new Array<SelectListItem>();
        let i = 1;
        data.Roles.forEach(it => {
          let o: SelectListItem = {
            value: it.RoleId,
            text: it.RoleName,
            index: i++
          };
          this.Doc.ddlRole.push(o);
        });
      }
    );
  }

  ngOnInit() {
    this.Doc.UserAccount = '';
    //this.Doc.RoleId = '0';

    this.Title = "Create";
  }

  isValid(): boolean {
    if (this.Doc.RoleId !== '0' && this.Doc.UserAccount !== '') {
      return false;
    }

    return true;
  }

  onRoleChange(ddl) {
    this.Doc.SelectedRole = ddl;
    this.Doc.RoleId = ddl.value;
    if (this.Doc.RoleId !== '0') {
      this.Doc.GetDocument(this.Doc.RoleId)
    }
    else {
      this.Doc.ListUsers = null;
    }
  }

  Cancel() {
    let lastPageInfo = this.filterService.GetSearchInfo();
    if (lastPageInfo.RouteName) {
      this.router.navigate([lastPageInfo.RouteName]);
    }
    else
      this.router.navigate(['/Home/RoleUsers']);
  }

  CanGetUserInfo() {
    if ((this.Doc.UserAccount !== '' && this.Doc.UserAccount !== null)) {
      return false;
    }

    return true;
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => {
        this.searchList = [];
        this.searching = true;
        //this.SelectedUser = {};
        this.Doc.UserAccount = '';
      }),
      switchMap(term => term.trim() !== '' ?
        this.http.get(`${environment.APIBaseUrl}${this.UserProfileAutoComplete}/${term}`).pipe(
          tap(() => {
            this.searchFailed = false;
          }),
          map((ret) => {
            this.searchList = ret["Data"];
            return ret["Data"];
          }),
          catchError(() => {
            this.searchFailed = true;
            this.searchList = [];
            this.SelectedUser = {};
            this.Doc.UserAccount = '';
            return of([]);
          })) : of([])
      ),
      tap(() => this.searching = false)
    );

  formatter = (x: RoleUsers) => x.UserAccount;

  selectedItem(item) {
    let SelectedUser = item.item;
    this.Doc.UserAccount = SelectedUser.UserAccount;
  }

  Submit() {
    if (this.DocMode === "NEW") {
      // if (this.SelectedUser && this.SelectedUser.UserAccount) {
      //   this.Doc.UserAccount = this.SelectedUser.UserAccount;
      // }

      let postData: RoleUsers = {
        RoleId: this.Doc.RoleId,
        RoleName: this.Doc.RoleName,
        UserAccount: this.Doc.UserAccount
      };

      this.dataService.addData(this.ControllerName, postData, (ret) => {
        let result = this.DlgService.CreateSubmit();
        result.then((ret) => {
          if (ret === 'Back') {
            this.Cancel();
          }
          else if (ret === 'Create Another') {
            this.Doc.RoleId = '';
            this.Doc.UserAccount = '';
            this.Doc.ListUsers = null;
            this.SelectedUser = {};
          }
        }).catch((error) => {
          console.error(error);
        });
      });

    }
  }
}
